import { Menu, MenuItem, Typography } from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SubMenuLegal = ({ openMenu, setOpenMenu, onClick }) => {
  return (
    <div>
      <Typography
        variant="footerlink"
        fontSize={["18px", "18px", "16px", "18px", "18px"]}
        onClick={onClick}
        sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        Legal <KeyboardArrowDownIcon />
      </Typography>

      <Menu
        anchorEl={openMenu}
        open={openMenu}
        onClose={() => setOpenMenu(false)}
        style={{ marginTop: "0.5rem" }}
      >
        <a
          href="https://photographerondemand.in/termsofservice"
          style={{ textDecoration: "none", color: "inherit" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MenuItem
            style={{ fontSize: "14px" }}
            onClick={() => setOpenMenu(false)}
          >
            <Typography sx={{ fontSize: "1rem", color: "black" }}>
              Terms & Conditions
            </Typography>
          </MenuItem>
        </a>

        <a
          href="https://photographerondemand.in/privacypolicy"
          style={{ textDecoration: "none", color: "inherit" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MenuItem
            style={{ fontSize: "14px" }}
            onClick={() => setOpenMenu(false)}
          >
            <Typography sx={{ fontSize: "1rem", color: "black" }}>
              Privacy policy
            </Typography>
          </MenuItem>
        </a>

        <a
          href="https://photographerondemand.in/refundpolicy"
          style={{ textDecoration: "none", color: "inherit" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MenuItem
            style={{ fontSize: "14px" }}
            onClick={() => setOpenMenu(false)}
          >
            <Typography sx={{ fontSize: "1rem", color: "black" }}>
              Refund policy
            </Typography>
          </MenuItem>
        </a>
      </Menu>
    </div>
  );
};

export default SubMenuLegal;
